import React from 'react';

import classNames from 'classnames';
import Loader from 'components/Loader';

import redTrash from 'assets/icons/red-trash.svg';

import './styles.css';

class Button extends React.Component<any> {
  static defaultProps = {
    isLoading: false,
    disabled: false
  };

  render() {
    const {
      isLoading,
      className,
      children,
      disabled,
      onClick,
      transparent,
      white,
      primary,
      active,
      red,
      blue,
      onBlur,
      type,
      clear
    } = this.props;

    return (
      <button
        type={type}
        className={classNames(
          className,
          'Button colab-bold',
          {
            isLoading,
            transparent,
            white,
            primary,
            active,
            red,
            disabled,
            blue,
            clear
          },
          {'colab-centered colab-small-border-radius': clear}
        )}
        onClick={onClick}
        onBlur={onBlur}
        disabled={disabled || isLoading}>
        {isLoading && <Loader />}
        {!isLoading && !clear && children}
        {clear && (
          <React.Fragment>
            <div>
              <img src={redTrash} alt="Clear Icon" />
            </div>
            <div className="colab-centered">{children}</div>
          </React.Fragment>
        )}
      </button>
    );
  }
}

export default Button;
